module.exports = __webpack_public_path__ + "img/image07.5cd1ecbd.jpg";